import React from "react";
import Contact from "../components/Contact";
import Layout from "../components/Layout";
import SubHeader from "../components/SubHeader";

const contact = () => {
   return (
      <Layout>
         <SubHeader />
         <Contact />
      </Layout>
   );
};

export default contact;
